import { getDB } from './schema';
import type { ContentRow } from '../types/content';
import type { ContentType } from '../types/stream';

// Persistence for playlist content rows. Mirrors ContentDAO.

export const contentRepo = {
  async getAll(types: ContentType[] = ['video', 'image']): Promise<ContentRow[]> {
    const db = await getDB();
    const all = await db.getAll('content');
    return all
      .filter((c) => types.includes(c.type))
      .sort((a, b) => a.position - b.position);
  },

  async getByUuid(uuid: string): Promise<ContentRow | undefined> {
    const db = await getDB();
    return db.get('content', uuid);
  },

  async count(): Promise<number> {
    const db = await getDB();
    return db.count('content');
  },

  async put(row: ContentRow): Promise<void> {
    const db = await getDB();
    await db.put('content', row);
  },

  async delete(uuid: string): Promise<void> {
    const db = await getDB();
    await db.delete('content', uuid);
  },

  // Rows tagged with a sequence older than the given one (stale content).
  async getOlderThan(sequence: number): Promise<ContentRow[]> {
    const db = await getDB();
    const all = await db.getAll('content');
    return all.filter((c) => c.sequence < sequence);
  },
};
